(function () {
  'use strict';

  var DEBUG = window.location.search.indexOf('debug_mode=true') !== -1;

  var rail = document.getElementById('psw-vrail');
  if (!rail) return;

  var btnPrev = document.getElementById('psw-vprev');
  var btnNext = document.getElementById('psw-vnext');

  // ── Scroll navigation ──────────────────────────────────────────────────────

  function getScrollAmount() {
    var card = rail.querySelector('.psw-vcard');
    if (!card) return 266;
    var gap = parseInt(getComputedStyle(rail).gap, 10) || 20;
    return card.offsetWidth + gap;
  }

  if (btnPrev) {
    btnPrev.addEventListener('click', function () {
      rail.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });
  }

  if (btnNext) {
    btnNext.addEventListener('click', function () {
      rail.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });
  }

  // ── Per-card play buttons ──────────────────────────────────────────────────

  rail.addEventListener('click', function (e) {
    var btn = e.target.closest('.psw-vplay');
    if (!btn) return;

    var fig = btn.closest('.psw-vfig');
    if (!fig) return;

    var video = fig.querySelector('video');
    if (!video) return;

    // Pause all other videos in this rail and restore their play buttons
    rail.querySelectorAll('video').forEach(function (other) {
      if (other === video) return;
      other.pause();
      var otherFig = other.closest('.psw-vfig');
      if (otherFig) {
        var otherBtn = otherFig.querySelector('.psw-vplay');
        if (otherBtn) otherBtn.style.display = '';
      }
    });

    btn.style.display = 'none';
    video.muted = false;
    video.controls = true;
    video.play().catch(function () {
      // Autoplay blocked — restore play button
      btn.style.display = '';
      if (DEBUG) console.log('[psw-tt-celeb] play blocked by browser');
    });

    if (DEBUG) console.log('[psw-tt-celeb] playing:', video.src);
  });

})();
